/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

(function (window, $) {
    'use strict';
    var document = window.document;

    var jsDoFilter = {

        init: function () {
            // add click event on parent li, div, etc ... with a <a class="js-do-click-target"></a> has children
            $(".filter__link").click(function (event) {
                if($(this).parent().hasClass('filter--active'))
                    return;

                var filter = $(this).attr('data-filter');
                $('.filter--active').removeClass('filter--active');
                $(this).parent().addClass('filter--active');

                $('.results__content-link').each(function (index){
                    if(filter == 'all'){
                        $(this).fadeIn(250);
                    }else{
                        var type = $(this).attr('data-type');
                        if(type != filter)
                            $(this).fadeOut(250);
                        else
                            $(this).fadeIn(250);
                    }
                });
            });
        }
    };

    $(document).ready(function () {
        jsDoFilter.init();
    });

})(window,jQuery);


